import React from "react";
import "../styles/service.css";
import Navbar from "../components/layout/Navbar";
import SeoHead from "../components/SeoHead";

const CONDITIONS = [
  {
    title: "Scaphoid Fractures",
    desc: "Precise treatment for scaphoid bone fractures, often missed on initial X-rays.",
  },
  {
    title: "Non-Union Scaphoid",
    desc: "Specialized care for scaphoid fractures that fail to heal naturally.",
  },
  {
    title: "Vascularised Bone Grafting",
    desc: "Advanced microsurgery using blood-supplied grafts to heal stubborn fractures.",
  },
  {
    title: "Kienbock's Disease",
    desc: "Surgical management of lunate bone damage to relieve pain and restore function.",
  },
  {
    title: "Perilunate Injuries",
    desc: "Urgent repair of complex dislocations and ligament tears around the lunate.",
  },
  {
    title: "Complex Carpal Injuries",
    desc: "Reconstructive surgery for multi-bone fractures and combined wrist trauma.",
  },
  {
    title: "Carpal Instability",
    desc: "Ligament reconstruction to restore alignment and strength in unstable wrists.",
  },
  {
    title: "Distal Radius Fractures",
    desc: "Accurate realignment and fixation of the most common wrist fracture.",
  },
  {
    title: "Malunion & Non-Union Fractures",
    desc: "Corrective surgery for wrist fractures that healed poorly or never united.",
  },
  {
    title: "Scapholunate Injuries",
    desc: "Repair of the key ligament connecting scaphoid and lunate bones.",
  },
  {
    title: "DRUJ & TFCC Disorders",
    desc: "Arthroscopic treatment for distal radioulnar joint and cartilage injuries.",
  },
  {
    title: "Arthritis of Wrist",
    desc: "Comprehensive care from joint preservation to replacement for painful arthritis.",
  },
  {
    title: "Wrist Arthroscopy",
    desc: "Minimally invasive keyhole surgery for faster diagnosis and recovery.",
  },
];

const GALLERY = [1,2,3].map((n) => ({
  src: `/images/wrist${n}.jpeg`,
  alt: `Wrist surgery case ${n}`,
}));

export default function WristSurgery() {
  return (
    <div className="hs-page">

      <SeoHead
        title="Wrist Surgery & Arthroscopy in Hyderabad | Dr. R. Suneel"
        description="Expert wrist arthroscopy, scaphoid & distal radius fracture management, TFCC repair and wrist instability treatment in Hyderabad."
        keywords="wrist surgery Hyderabad, wrist surgeon Hyderabad, best wrist specialist Hyderabad, wrist arthroscopy Hyderabad, wrist fracture treatment Hyderabad, TFCC tear treatment Hyderabad, scaphoid fracture surgery, wrist ligament injury treatment, wrist arthritis treatment, ganglion cyst surgery Hyderabad, Dr R Suneel wrist surgeon, Medicover wrist surgery Hyderabad"
        url="https://www.handandwristclinics.com/wrist"
        image="https://www.handandwristclinics.com/static/media/wrist_surgery.png"
      />

      {/* HERO + BREADCRUMB */}
      <header className="hs-hero">
        <div className="hs-hero-inner">
          <nav className="hs-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="hs-bc-sep">/</span>
            <a href="/services">Services</a>
            <span className="hs-bc-sep">/</span>
            <span className="hs-bc-current">wrist Surgery</span>
          </nav>
          <div className="hs-eyebrow">
            <span></span> Specialized Hand & Wrist Care
          </div>
          <h1 className="hs-title">
            Wrist <em>Surgery</em>
          </h1>
          <div className="hs-divider" />
          <p className="hs-hero-sub">
            Advanced surgical treatment to restore function, strength, and mobility
            to injured or impaired hands.
          </p>
        </div>
      </header>

      {/* INTRO */}
      <section className="hs-section hs-intro">
        <div className="hs-container">
          <div className="hs-section-tag">About the Procedure</div>
          <h2 className="hs-section-title">
            Restoring the intricate <em>function of your Wrist</em>
          </h2>
          <div className="hs-divider" />
          <p className="hs-intro-text">
            Hand and Wrist problems can impact anybody, young or old. They may significantly affect your function and quality of life. These unique organs of the body render you with the capability to produce excessive force for activities. Dr. R. Suneel is expert in the complexities of hand and wrist anatomy as well as arthroscopy surgeries in Madhapur

Based on the diagnosis at best wrist injury clinic in Hyderabad, the prescribed treatment may involve surgical or non-surgical options.

Elementary procedures are required to treat wrist problems that are mild to extreme. They usually begin with reducing pain and inflammation before going ahead to more vigorous orthopedic treatments at center for wrist surgery in Hyderabad. Sometimes, wrist treatments in Malakpet include training the individual to make use of their wrist in a different manner for high-impact activities such as swinging a hammer or throwing a ball.

As the wrist suffers the damage like broken bones, torn ligaments, injured nerves, complex wrist surgeries may be needed.
          </p>
          <p className="hs-intro-text">
            Consult wrist specialist in Hyderabad.

First step to stop wrist pain is to properly diagnose the problem's cause. Wrist specialist in Malakpet can identify the vast ranging number of wrist conditions that might be the reason for medical condition, whether it's related to injury or disorder. Visit best hospital for wrist injury in Hyderabad.
          </p>
        </div>
      </section>

      {/* CONDITIONS GRID */}
      <section className="hs-section hs-conditions">
        <div className="hs-container">
          <div className="hs-section-head">
            <div className="hs-section-tag">Conditions We Treat</div>
            <h2 className="hs-section-title">
              Comprehensive <em>hand & wrist</em> treatment
            </h2>
            <div className="hs-divider" />
            <p className="hs-section-sub">
              From traumatic injuries to congenital conditions, we offer surgical
              expertise across the full spectrum of wrist disorders.
            </p>
          </div>

          <div className="hs-grid">
            {CONDITIONS.map((c, i) => (
              <article className="hs-card" key={i}>
                <div className="hs-card-num">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="hs-card-title">{c.title}</h3>
                <p className="hs-card-desc">{c.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* SMALL TEXT / CLOSING NOTE */}
      <section className="hs-section hs-note">
        <div className="hs-container hs-note-inner">
          <p className="hs-note-text">
            Every hand is unique — and so is every treatment plan. Our team
            combines microsurgical precision with years of specialist experience to
            deliver personalized care tailored to your recovery goals.
          </p>
        </div>
      </section>

      {/* IMAGE GALLERY */}
      <section className="hs-section hs-gallery-section">
        <div className="hs-container">
          <div className="hs-section-head hs-center">
            <div className="hs-section-tag">Case Gallery</div>
            <h2 className="hs-section-title">
              Results from our <em>wrist surgery</em> cases
            </h2>
            <div className="hs-divider hs-center-divider" />
          </div>

          <div className="hs-gallery">
            {GALLERY.map((img, i) => (
              <figure className="hs-gallery-item" key={i}>
                <img src={img.src} alt={img.alt} loading="lazy" />
                <figcaption className="hs-gallery-cap">
                  Case {String(i + 1).padStart(2, "0")}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      
    </div>
  );
}